import React from 'react';
import { useTranslation } from 'react-i18next';

import { LinkVariant } from 'src/api/contentful/contentTypes.cloverdotcom';
import { useCart } from 'src/components/Cart/UseCart';
import { StructuredModal, StructuredModalState } from 'src/components/StructuredModal/StructuredModal';

export type RemoveCartItemModalProps = {
  modalState: StructuredModalState;
};

export const RemoveCartItemModal: React.FC<RemoveCartItemModalProps> = ({ modalState }) => {
  const { t } = useTranslation();
  const { emptyCart } = useCart();
  return (
    <StructuredModal
      modalState={modalState}
      title={t('remove-cart-item.title')}
      description={t('remove-cart-item.description')}
      actions={[
        {
          label: t('cancel'),
          variant: LinkVariant.SECONDARY,
          isCloseButton: true,
        },
        {
          label: t('confirm'),
          variant: LinkVariant.PRIMARY,
          action: emptyCart,
        },
      ]}
    />
  );
};
